import { Tables } from "@/lib/supabase/supabase_types_override"
import { queryKeys } from "@/lib/useQuery/queryKeys"
import { useQuery } from "@tanstack/react-query"

export function useCrmConfigsByCrmProjectId(crmProjectId?: Tables<"crm_project">["id"]) {
    return useQuery({
        ...queryKeys.crm_config.list._ctx.byCrmProjectId(crmProjectId!),
        enabled: !!crmProjectId
    })
}